
let news = [];
const bookmarks = {
    en: [],
    de: [],
    fr: [],
    es: [],
    it: [],
    'pt-br': [],
};
const currentPages = {
    threats: 1,
    'how-to': 1,
};

const NewsRepository = {

    setPages(numberofpages) {

        news = new Array(numberofpages).fill(null);

        return news;

    },

    replace(data, page, category) {

        const categories = {
            threats: [],
            'how-to': [],
        };

        if (typeof data !== 'undefined' && typeof page !== 'undefined' && typeof category !== 'undefined') {

            if (!news[page - 1]) {

                news[page - 1] = categories;

            }

            news[page - 1][category] = data;

        }

        return news;

    },

    replaceBookmarks(data, language) {

        const bookmark = bookmarks[language]
            .find(element => element.id === data.id);

        if (!bookmark) {

            bookmarks[language].push(data);

        }

    },

    getAll() {

        return news;

    },

    getAllBookmarks() {

        return bookmarks;

    },

    deleteBookmark(articleId, language) {

        bookmarks[language].forEach((article) => {

            if (articleId === article.id) {

                const remove = function remove(array, element) {

                    return array.filter(el => el.id !== element.id);

                };

                bookmarks[language] = remove(bookmarks[language], article);

            }

        });

        return bookmarks;

    },

    addBookmark(data, language) {

        bookmarks[language].push(data);

    },

    getPageNumber() {

        return currentPages;

    },

    updateCurrentPage(category, pageNumber) {

        currentPages[category] = parseInt(pageNumber, 0);
        return currentPages;

    },

};

export default NewsRepository;



// WEBPACK FOOTER //
// ./scripts/common/repositories/-RFC.newsRepository.js